import { render, staticRenderFns } from "./OnboardSetup.vue?vue&type=template&id=602ae9ac&"
import script from "./OnboardSetup.vue?vue&type=script&lang=js&"
export * from "./OnboardSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports